import React, { Component } from "react";
import { Container } from "react-bootstrap";

export default class Contacts extends Component {
  render() {
    return (
      <>
        <Container>
          <h2>Нас можно найти по адресу</h2>

       <h3>Контактные данные:</h3>
       <p>МТС:786-18-18</p>
       </Container>
      </>
    );
  }
}
